import React from "react";
import './index.css'
import {useSelector} from "react-redux";

const Loading = ({isSmall = false}) => {

    const {configuration} = useSelector(state => state.globalReducer)

    if (!configuration?.icon)
        return null

    if (isSmall)
        return (
            <div className="fade-in loader-logo small">
                <img loading="lazy"src={configuration?.icon} alt={'logo'}/>
            </div>
        )


    return <div className={'fade-in loading-container section'}>
        <div className="loader-logo">
            <img loading="lazy" src={configuration?.icon} alt={'logo'}/>
        </div>
    </div>

}

export default React.memo(Loading)
